import { render } from "./nav-main.vue?vue&type=template&id=60a65627"
import script from "./nav-main.vue?vue&type=script&lang=js"
export * from "./nav-main.vue?vue&type=script&lang=js"

import "./nav-main.vue?vue&type=style&index=0&id=60a65627&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__